import React from 'react';

import { useLocation } from 'react-router-dom';
import { nativeLensId } from '~/nativeLenses/nativeLensId';
import { nativePageRoutes } from '~/nativeLenses/pageRoutes';

import { Box, LinearProgress } from '@mui/material';

import { useGetReportingLeLenses } from '~/hooks/apis/reporting/useGetReportingLeLens';

import PersonalViewBoundary from './PersonalViewBoundary';
import { useViewEntryRevision } from './useViewEntryRevision';

/** The native page still owns its renderer, query codec, permissions and PageChat bridge. */
export default function NativePersonalViewBoundary({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const route = nativePageRoutes.find((page) => page.path === location.pathname);
  const lenses = useGetReportingLeLenses();
  const entryRevision = useViewEntryRevision();
  const lens = route ? lenses.data?.find((entry) => entry.id === nativeLensId(route.pageId)) : undefined;
  if (route && lenses.isPending)
    return (
      <Box role="status" aria-label="Loading report views" sx={{ p: 2 }}>
        <LinearProgress />
      </Box>
    );
  // Registration and availability remain governed by the existing Library, never by a saved link.
  if (!lens) return <>{children}</>;
  return (
    <PersonalViewBoundary
      key={`${lens.id}:${entryRevision}`}
      lensId={lens.id}
      reportVersion={lens.publication?.publishedVersion ?? lens.version}
      kind="native"
    >
      {children}
    </PersonalViewBoundary>
  );
}
